module.exports = __webpack_public_path__ + "static/media/langauge_logo.a5a8f18c.svg";